import { useQuery } from '@tanstack/react-query';

import { ApiError } from '@/lib/apiClient';

import { getMe } from './api';

export const ME_KEY = ['me'] as const;

/**
 * Estado da conta.
 *
 * Funciona antes de o perfil existir: quem acabou de confirmar o e-mail recebe
 * `onboarding_status: "pending"` em vez de um 404. É essa resposta que decide
 * entre mostrar o onboarding e mostrar a aplicação.
 */
export function useMe({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: getMe,
    // `enabled` existe por causa da página pública do convite: sem ele, toda
    // abertura de link compartilhado disparava um `GET /me` sem token e somava
    // um 401 ao log — justamente na rota de maior acesso anônimo, e sem
    // utilidade, já que o resultado só é usado quando há sessão.
    enabled,
    // Sem repetição em 401: o token venceu ou é inválido, e insistir só
    // atrasa a ida para o login.
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status < 500) return false;
      return failureCount < 2;
    },
    staleTime: 60_000,
  });
}
